import type { FC, HTMLAttributes } from 'react';

type TopBarContentProps = HTMLAttributes<HTMLDivElement>;

const TopBarContent: FC<TopBarContentProps> = ({ ...props }) => <div {...props} />;

export { TopBarContent };
